export const API_URL =
  "https://api-smartcity.quecko.org";
  // "http://192.168.30.183:8088";
 